import React from 'react';
import { Box } from '@mui/material';
import Navbar from '../Navbar';
import Sidebar from '../SideBar/Sidebar';
import {
  useSidebarRail,
  SIDEBAR_RAIL_COLLAPSED_PX,
  SIDEBAR_RAIL_EXPANDED_PX,
  SIDEBAR_XS_WIDTH_PX,
} from '../../context/SidebarRailContext';
import { useAuth } from '../../hooks/useAuth';

const CONTENT_MARGIN_TOP_DEFAULT = 80;
const CONTENT_MARGIN_TOP_IMPERSONATING = 120;

const PageLayout = ({ children, sx = {}, ...rest }) => {
  const { railExpanded } = useSidebarRail();
  const { impersonating } = useAuth();
  const smOffset = railExpanded ? SIDEBAR_RAIL_EXPANDED_PX : SIDEBAR_RAIL_COLLAPSED_PX;

  // Navbar + Sidebar are position:fixed (out of flex flow), so this is the only flex child.
  // Explicit width + marginLeft prevents the column from staying full viewport width and sitting under the sidebar.
  const contentStyles = {
    flex: '0 0 auto',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    marginLeft: { xs: `${SIDEBAR_XS_WIDTH_PX}px`, sm: `${smOffset}px` },
    width: {
      xs: `calc(100% - ${SIDEBAR_XS_WIDTH_PX}px)`,
      sm: `calc(100% - ${smOffset}px)`,
    },
    maxWidth: {
      xs: `calc(100% - ${SIDEBAR_XS_WIDTH_PX}px)`,
      sm: `calc(100% - ${smOffset}px)`,
    },
    marginTop: impersonating ? `${CONTENT_MARGIN_TOP_IMPERSONATING}px` : `${CONTENT_MARGIN_TOP_DEFAULT}px`,
    minWidth: 0,
    overflowX: 'hidden',
    transition: (theme) =>
      theme.transitions.create(['margin-left', 'width', 'max-width'], {
        duration: 220,
        easing: theme.transitions.easing.easeInOut,
      }),
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }} {...rest}>
      <Navbar />
      <Sidebar />
      <Box sx={{ ...contentStyles, ...sx }}>{children}</Box>
    </Box>
  );
};

/**
 * Standard page layout with Navbar + Sidebar + content area.
 * Main body margin tracks sidebar width (sm+: 72px collapsed / 250px expanded).
 * Sidebar rail open/closed state is provided at the app root (SidebarRailProvider) so it persists across routes.
 */
export default PageLayout;
